(()=> {
  const selectors = {
    mobileSlider: '.featuredReviews__itemsSlider--mobile',
    slider: '.featuredReviews__itemsSlider'
  };

  var mobileSliderSettings = {
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    infinity: false,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 823,
        settings: 'unslick'
      }
    ]
  };

  var desktopSliderSettings = {
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    infinity: false,
    responsive: [
      {
        breakpoint: 823,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  };

  // ADA DEV-14567: Slick marks off-screen slides with aria-hidden="true" but leaves
  // focusable children (links, buttons) in the tab order. This helper removes keyboard
  // focus from interactive elements inside hidden slides, and restores it when visible.
  function syncSlideTabIndex(slider) {
    slider.find('.slick-slide').each(function() {
      var hidden = $(this).attr('aria-hidden') === 'true';
      $(this).find('a, button, input, select, textarea').each(function() {
        if (hidden) {
          $(this).attr('tabindex', '-1');
        } else {
          $(this).attr('tabindex', '0');
        }
      });
    });
  }

  function initSliders() {
    var $mobileSlider = $(selectors.mobileSlider).not('.slick-initialized');
    var $desktopSlider = $(selectors.slider).not('.slick-initialized');

    $mobileSlider.slick(mobileSliderSettings);
    $desktopSlider.slick(desktopSliderSettings);

    // a11y tweaks
    $('.featuredReviews__item').each(function() {
      $(this).removeAttr('aria-describedby');
    })

    $('.featuredReviews__items .slick-dots li button').each(function() {
      $(this).removeAttr('aria-controls');
    });

    // Sync tabindex on init and after every slide change so keyboard users
    // cannot tab into off-screen (aria-hidden) slides — WCAG 2.1.1 / 2.4.3
    $(selectors.mobileSlider + ', ' + selectors.slider).each(function() {
      syncSlideTabIndex($(this));
      $(this).on('afterChange', function() {
        syncSlideTabIndex($(this));
      });
    });
  };

  initSliders();
  window.addEventListener('resize', initSliders)
})();
